function observerRPC() {
    const scopeMap = new Map();
    return Object.freeze({
        add: scopeMap.set.bind(scopeMap),
        clear: scopeMap.clear.bind(scopeMap),
        remove: scopeMap.delete.bind(scopeMap),
        brodcastScope: (data, options)=>{
            const { exclude, include, scopein, scopeout, fallback } = options ?? {};
            let result = {};
            scopeMap.forEach((scope, item)=>{
                const type = item.getType();
                if (item.connected() && !exclude?.includes(type) && (include?.includes(type) ?? true) && !scopeout?.includes(scope) && (scopein?.includes(scope) ?? true)) result = item.broadcast({
                    ...data,
                    requestId: data.requestId ?? result.requestId,
                    sign: data.sign ?? result.sign
                }, fallback);
            });
        }
    });
}
export { observerRPC };
